import React from 'react';
import PropTypes from 'prop-types';
import { Card, Button, CardContent } from '@design-system-coopeuch/web';
import btnCerrar from '../../../assets/img/icon/btn-cerrar.svg';
import { WrapperModal } from './styles';
import { properties } from '../../../../utils/properties';
import { useDevice } from '../../../../hooks';
import IconPersonWarning from '../../../assets/img/icon/User-Warning.svg';
import IconPersonWarningMobile from '../../../assets/img/icon/User-Warning-Mobile.svg';

const ModalRevisaDatosRenta = ({
  setOpenModalRevisaDatosRenta,
  siguienteStep,
  estadoBotonAvanzar,
}) => {

  const { isMobile } = useDevice();
  
  return (
    <WrapperModal>
      <div className="modal">
        <div className="modal-content">
          <Card>
            <CardContent className="tituloModal">
              <div className="barraTop">
                <Button
                  variant="text"
                  onClick={() => setOpenModalRevisaDatosRenta(false)}
                  disabled={estadoBotonAvanzar}
                >
                  <img src={btnCerrar} alt="close" />
                </Button>
              </div>
            </CardContent>
            <CardContent className="cardSiguiente">
              <div className="iconUserContainer">
                <img
                  className="iconUser"
                  src={isMobile ? IconPersonWarningMobile : IconPersonWarning}
                  alt="icon-person-warning"
                />
              </div>
              <div className="titulo">{properties.pasos.paso2.modalRevisaDatosRenta.titulo}</div>
              <div className="subtitulo">
                <span>{properties.pasos.paso2.modalRevisaDatosRenta.descripcion}</span>
                <span className="descriptionBold">
                  {properties.pasos.paso2.modalRevisaDatosRenta.descripcion2}
                </span>
                <span>{properties.pasos.paso2.modalRevisaDatosRenta.descripcion3}</span>
                <span className="descriptionBold">
                  {properties.pasos.paso2.modalRevisaDatosRenta.descripcion4}
                </span>
                <p>
                  <span>{properties.pasos.paso2.modalRevisaDatosRenta.descripcion5}</span>
                </p>
              </div>
              <div className="volver">
                <Button
                  className="retomarFormBoton"
                  variant="text"
                  onClick={() => setOpenModalRevisaDatosRenta(false)}
                  disabled={estadoBotonAvanzar}
                >
                  Volver y modificar
                </Button>
                <Button
                  className="botonTerminar"
                  variant="outline"
                  onClick={() => siguienteStep()}
                  disabled={estadoBotonAvanzar}
                >
                  {properties.pasos.paso2.modalRevisaDatosRenta.botonContinuar}
                </Button>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </WrapperModal>
  );
};

ModalRevisaDatosRenta.propTypes = {
  setOpenModalRevisaDatosRenta: PropTypes.func.isRequired,
  siguienteStep: PropTypes.func.isRequired,
  estadoBotonAvanzar: PropTypes.bool.isRequired,
};

export default ModalRevisaDatosRenta;
